import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import SetTitle from '../../components/shared/SetTitle';
import { request, handleRequestErrors } from '../../helpers/Requests'

class LocationName extends Component {
  render() {
    const { location, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const name = this.props.name || location.name

      return (
        <div>
          <SetTitle title={`${name} | Locations`} />
          {name}
        </div>
      );
    }
  }

  state = {
    location: [],
    loaded: false,
    error: null,
    unauthorized: null
  };

  componentDidMount() {
    var id = this.props.id;

    request("GET", `/v1/a/locations/${id}`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({ location: data, loaded: true })
        this.props.updateName(data.name)
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default LocationName;
